"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const S = __importStar(require("./LoadingIndicator.styles"));
const LoadingIcon_1 = __importDefault(require("../Icons/LoadingIcon"));
const LoadingIndicator = ({ testID = 'loadingIndicator', color, loadingText, }) => {
    const spinValue = new react_native_1.Animated.Value(0);
    // First set up animation
    react_native_1.Animated.loop(react_native_1.Animated.timing(spinValue, {
        toValue: 1,
        duration: 1000,
        easing: react_native_1.Easing.linear,
        useNativeDriver: false,
    })).start();
    // Second interpolate beginning and end values (in this case 0 and 1)
    const spin = spinValue.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
    });
    return (react_1.default.createElement(S.StyledWrapper, { testID: testID },
        react_1.default.createElement(S.IconWrapper, null,
            react_1.default.createElement(react_native_1.Animated.View, { style: { transform: [{ rotate: spin }] } },
                react_1.default.createElement(LoadingIcon_1.default, { color: color }))),
        loadingText && react_1.default.createElement(S.Text, null,
            loadingText,
            "...")));
};
exports.default = LoadingIndicator;
